import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const AREAS = [
  "The Levant & Middle Eastern energy corridors",
  "Political Islam & de-radicalization in Europe",
  "Moral psychology & comparative mythology",
  "Narrative warfare, disinformation & propaganda",
];

const PUBS = [
  { label: "Visegrad24", url: "https://www.visegrad24.com/authors/dre-lapiello" },
  { label: "OFCS.Report", url: "https://ofcs.report/author/dre-lapiello/" },
  { label: "Osservatorio Mashrek", url: "https://www.osservatoriomashrek.com/author/dre-lapiello" },
];

export default function About({ author }) {
  return (
    <section id="about" className="scroll-mt-20 relative py-16 sm:py-24 border-t border-[var(--line)] mt-16">
      <div className="max-w-[1320px] mx-auto px-5 sm:px-8">
        <p className="meta-label text-[var(--gold)]">Analyst Profile &amp; Method</p>
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-10 lg:gap-16 mt-6">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <h2 className="font-serif text-4xl sm:text-5xl text-[var(--txt)] leading-[1.05]">
              Who is writing, <span className="italic text-[var(--gold)]">and why</span>.
            </h2>
            <p className="mt-6 text-[0.98rem] text-[var(--txt-2)] leading-[1.8] max-w-2xl">
              {author?.bio}
            </p>
            {author?.stats && (
              <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3">
                {Object.values(author.stats).map((s) => (
                  <span key={s} className="meta-label text-[0.56rem] text-[var(--muted)] flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-[var(--gold)]" /> {s}
                  </span>
                ))}
              </div>
            )}
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }}
            className="space-y-8">
            <div>
              <p className="meta-label text-[var(--muted)] mb-3">Research Areas</p>
              <ul className="space-y-2.5">
                {AREAS.map((a) => (
                  <li key={a} className="text-[0.9rem] text-[var(--txt-2)] pl-4 border-l border-[var(--line-2)] leading-snug py-0.5">{a}</li>
                ))}
              </ul>
            </div>
            <div>
              <p className="meta-label text-[var(--muted)] mb-3">Published In</p>
              <div className="flex flex-col divide-y divide-[var(--line)] border-t border-b border-[var(--line)]">
                {PUBS.map((p) => (
                  <a key={p.label} data-testid={`pub-${p.label}`} href={p.url} target="_blank" rel="noopener noreferrer"
                    className="group flex items-center justify-between py-3 text-[0.9rem] text-[var(--txt-2)] hover:text-[var(--gold)] transition-colors">
                    {p.label}
                    <ArrowUpRight size={14} className="text-[var(--muted)] group-hover:text-[var(--gold)]" />
                  </a>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
